import { connect } from 'react-redux';
import {
  ssoIdpAuthReceiveCode,
  ssoIdpAuthReceiveToken,
  ssoAuthError,
  authWithSSO,
} from '../../../actions';

import SSOAuthLoadingView from './SSOAuthLoadingView';

const mapStateToProps = (state) => {
  const { idpConfig, session } = state;

  return {
    idpConfig,
    session,
  };
};
export default connect(mapStateToProps, {
  ssoIdpAuthReceiveCode,
  ssoIdpAuthReceiveToken,
  ssoAuthError,
  authWithSSO,
})(SSOAuthLoadingView);
